import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import ProgramApplications from "../components/ProgramApplications";
import EnrollmentApplication from "../components/EnrollmentApplication";
import { useLocation } from "react-router-dom";
import WebForm from "./WebForm";
import TaxReturnForm from "./TaxReturnForm"; // Import the TaxReturnForm component
import TaxReturnPb from "./TaxReturnPb";
import ExcelUploader from "./ExcelUploader";
import CasinoTaxUploader from "./CanioUploader"
const Upload = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tabFromUrl = queryParams.get("tab") || "ProgramApplications"; // Default: "ProgramApplications"
    const itypeFromUrl = queryParams.get("itype"); // Get `itype` from the URL
    const stypeFromUrl = queryParams.get("stype")?.split('?')[0]; // Clean `stype` by removing query string
    const [activeComponent, setActiveComponent] = useState(tabFromUrl);

    const parseData = {
        iType: itypeFromUrl,
        sType: stypeFromUrl,
        activeComponent: activeComponent
        // Add more fields as needed
    };

    useEffect(() => {
        console.log(parseData)
        setActiveComponent(tabFromUrl);
    }, [location.search]); // Reacts to changes in query parameters

    // Function to render the appropriate component based on iType
    const renderContent = () => {
        if (itypeFromUrl?.toLowerCase() === 'fuel') {
            return <ExcelUploader />;
        }
        if (itypeFromUrl?.toLowerCase() === 'casino') {
            return <CasinoTaxUploader />;
        }
      
        return <WebForm parseData={parseData} />;
    };

    return (
        <div className="flex flex-col h-screen">
            {/* Header */}
            <div className="fixed top-0 left-0 w-full z-50 bg-primary">
                <Header />
            </div>

            {/* Main Layout */}
            <div className="flex flex-1 mt-[72px]">
                {/* Sidebar */}
                <div className="fixed left-0 w-64 bg-white shadow-md h-[calc(100vh-72px)] overflow-y-auto hidden lg:block">
                    <Sidebar />
                </div>

                {/* Main Content - Dynamic Rendering */}
                <main className="flex-1 p-6 bg-gray-100 overflow-y-auto mt-[25px] lg:ml-64">
                    {renderContent()}
                </main>
            </div>
        </div>
    );
};

export default Upload;